export default [
  {
    img: 'liberacao-passo-1',
    title:
      'Acesse o app Meu INSS com o seu CPF e sua senha utilizada no app Gov.br',
    text: 'Depois de acessar, autorize o uso de dados pessoais clicando em ”Autorizar".'
  },
  {
    img: 'liberacao-passo-2',
    title: 'Selecione a opção “Empréstimo (Bloqueio/Desbloqueio)”',
    text: 'Outra opção para solicitar o desbloqueio é ir em Novo Pedido, escrever a palavra desbloquear e seguir com o preenchimento das informações.'
  },
  {
    img: 'liberacao-passo-3',
    title: 'Clique em “avançar” para continuar a solicitação',
    text: 'É preciso aguardar para pedir o desbloqueio quando o benefício foi concedido há menos de 90 dias ou se solicitou a transferência do benefício há menos de 60 dias. '
  },
  {
    img: 'liberacao-passo-4',
    title: 'Preencha os campos e selecione a “Desbloqueio para empréstimo”',
    text: 'Você vai precisar do CPF, e-mail, telefone, se deseja acompanhar o processo por e-mail e o número do benefício. Você pode encontrar o número no menu clicando em “Extrato de Informações do Benefício”.'
  },
  {
    img: 'liberacao-passo-5',
    title: 'Agora basta anexar seus documentos e clicar em “Avançar”!',
    text: 'O prazo para retorno da solicitação é de 30 dias corridos, conforme informações do INSS. Para acompanhar a solicitação de desbloqueio clique em “Consultar Pedidos".'
  }
]
